import React from "react";
import { useTranslation } from "react-i18next";

const InvoiceSimulationHeader = () => { 
  // Translations
  const tLabels = useTranslation("invoiceSimulation\\invoiceSimulation").t;

  // RENDER
  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-end pl-3 pr-2 mr-5">
        <div className="col-sm-3 col-xl-2 mb-1 mb-sm-0">
          {tLabels("invoiceSimulation.timePeriod")}
        </div>
        <div className="col-sm-3 col-xl-2">
          {tLabels("invoiceSimulation.calculation")}
        </div>
        <div className="col-sm-3 col-xl-5 pr-2">
          <div className="row no-gutters">
            <div className="col-auto col-xl-6">
              {tLabels("invoiceSimulation.amount")}
            </div>
            <div className="col-auto col-xl-6">
              <span className="d-xl-none">/</span>
                {tLabels("invoiceSimulation.advance")}
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xl-3">
          {tLabels("invoiceSimulation.difference")}
        </div>
      </div>
    </div>
  );
};

export default InvoiceSimulationHeader;
